export const schemaV2 = {
    taxes: 'id, name, value, deleted, [id+deleted]',
    paymentMethods:
        'id, name, type, paymentMethodIndex, deleted, enabled, [id+deleted]',
    staff: 'id, authUserId, role, deleted, registerPin, [registerPin+deleted], [id+deleted]',

    items: 'id, name, itemType, categoryId, measurementUnitId, isActive, [id+isActive]',
    itemVariants:
        'id, name, sku, barcode, itemPriceType, itemId, deleted, [id+deleted]',
    itemVariantCompositions: 'id, variantId, deleted, [id+deleted]',

    categories: 'id, name, deleted, [id+deleted]',
    measurementUnits: 'id, name, deleted, [id+deleted]',
};
